import React from 'react'
import { Column } from 'react-virtualized'
import { components } from 'react-select'
import moment from 'moment'

import Table from '../../../containers/Tables/components/Table'
import TableStyles from '../../../containers/Tables/components/Table/Table.css'
import TableHeader from '../../../containers/Tables/components/TableHeader'
import TableActions from '../../../containers/Tables/components/TableActions'
import TableActionStyles from '../../../containers/Tables/components/TableActions/TableActions.css'
import {
  DatePopover,
  DropdownSearchPopover,
  ListPopover,
  MultiSelectListPopover,
} from '../../../containers/Popovers'
import styles from './PatientDirectoryTable.css'
import {
  PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS,
  ENROLLMENT_CONNECTION_STATUSES,
  getSexDisplayText,
  TABLE_CHECKBOX_WIDTH,
  EKG_TABLE_COLUMN_HEADERS,
} from '../../../constants'
import {
  getName,
  getPhysicianName,
  getPatientName,
  getPendingOrConnectedEnrollmentsByEndDate,
  isEscKey,
} from '../../../containers/Utilities'
import { DATE_WIDTH } from '../../../containers/Tables/Utilities'
import { filterIsPhysicianPermission } from '../../../store/appReducer'
import { getDateFormat } from '../../../../common/dateUtils'

class PatientDirectoryTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: {},
      isAnySelected: false,
    }
  }

  dateFormat = getDateFormat(this.props.me)

  handleOnSelectionClick = selected => {
    const {
      onSelectionClick,
    } = this.props

    const isAnySelected = Object.keys(selected).some(key => selected[key] === true)

    this.setState({
      selected,
      isAnySelected,
    })

    if (onSelectionClick) {
      onSelectionClick(selected)
    }
  }

  render() {
    const {
      noDataText = 'No patients found.',
      enableLoader,
      showLoader,
      data,
      showRowSelection = false,
      width,
      onRowClick,
      selectedIndex,
      sortBy,
      sortDirection,
      filterPatient,
      filterDate,
      filterBillingCode,
      filterPhysician,
      filterConnectionStatus,
      filterPrescription,
      handleOnFilterButtonClick,
      handleOnFilterChange,
      handleOnSortClick,
      handleOnOutsidePopoverClick,
      selectedPopover,

      selectedPatientId,
      patients,

      selectedStartDate,
      selectedEndDate,
      dateRange,

      selectedPhysicians,
      selectedPhysicianId,
      physicians,

      selectedConnectionStatus,
      connectionStatusesOptions,

      selectedPrescriptionId,
      prescriptions,
      enrollments,

      selectedBillingCode,
      billingCodes,
    } = this.props
    const {
      selected,
      isAnySelected,
    } = this.state

    const ROW_HEIGHT = 74
    const DOB_WIDTH = DATE_WIDTH
    const PATIENT_WIDTH = 190
    const BILLING_CODE_WIDTH = 110
    const ORDERING_PHYSICIAN_WIDTH = 190
    const CONNECTION_STATUS_WIDTH = 150
    let prescriptionWidth = width - PATIENT_WIDTH - DOB_WIDTH - BILLING_CODE_WIDTH - ORDERING_PHYSICIAN_WIDTH - CONNECTION_STATUS_WIDTH

    if (showRowSelection) {
      prescriptionWidth -= TABLE_CHECKBOX_WIDTH
    }

    let selectedPatient
    let patientsOptions

    if (patients && patients.data) {
      patientsOptions = patients.data.sortedByLastName.map(id => patients.data.byId[id])
      selectedPatient = selectedPatientId && patients.data.byId[selectedPatientId]
    }

    let physicianOptions = []
    const noneOptionItem = {
      id: '0',
      label: '<None>',
    }

    let selectedPhysician

    if (physicians && physicians.data) {
      physicianOptions = [ noneOptionItem ]
        .concat(filterIsPhysicianPermission(physicians.data.sortedByLastName.map(id => physicians.data.byId[id]))
          .map(p => ({
            id: p.id,
            label: getName(p.firstName, p.lastName, ''),
          })))

      selectedPhysician = selectedPhysicianId && physicians.data.byId[selectedPhysicianId]
    }

    let selectedPrescription
    let prescriptionsOptions

    if (prescriptions && prescriptions.data) {
      prescriptionsOptions = prescriptions.data.sortedByName.map(id => prescriptions.data.byId[id])
      selectedPrescription = selectedPrescriptionId && prescriptions.data.byId[selectedPrescriptionId]
    }

    let billingCodesOptions

    if (billingCodes && billingCodes.data) {
      billingCodesOptions = billingCodes.data.sortedByName.map(id => billingCodes.data.byId[id])
    }


    // console.log(data)

    const PATIENT_NAME_MRN_SPLIT_DELIMITER = '!~|~!~|~!'

    const Option = ({ children, ...props }) => {
      const parts = children.split(PATIENT_NAME_MRN_SPLIT_DELIMITER)
      const name = parts[0]
      const mrn = parts[1]

      return (
        <div className={styles.patientOption}>
          <components.Option {...props}>
            <p className={TableStyles.primaryText}>
              {name}
            </p>
            <p className={`${TableStyles.secondaryText} ${TableStyles.number}`}>
              {mrn}
            </p>
          </components.Option>
        </div>
      )
    }

    const SingleValue = ({ children, ...props }) => {
      const parts = children.split(PATIENT_NAME_MRN_SPLIT_DELIMITER)
      const name = parts[0]
      const mrn = parts[1]

      return (
        <div className={styles.patientOption}>
          <components.SingleValue {...props}>
            <p className={TableStyles.primaryText}>
              {name}
            </p>
            <p className={`${TableStyles.secondaryText} ${TableStyles.number}`}>
              {mrn}
            </p>
          </components.SingleValue>
        </div>
      )
    }

    return (
      <div
        className={styles.patientDirectoryTable}
        data-page="patient-directory-table"
        data-value={data.length}
      >
        <Table
          noDataText={noDataText}
          enableLoader={enableLoader}
          showLoader={showLoader}
          showRowSelection={showRowSelection}
          // headerHeight={35}
          rowHeight={ROW_HEIGHT}
          uniqueKey="id"
          hasTableActions={isAnySelected}
          onSelectionClick={this.handleOnSelectionClick}
          onRowClick={onRowClick}
          scrollToIndex={selectedIndex}
          data={data}
          sortBy={sortBy}
          sortDirection={sortDirection}
        >
          <Column
            className={TableStyles.column}
            width={PATIENT_WIDTH}
            label="Patient"
            dataKey={PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS.PATIENT} // not needed but field required by library
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS.PATIENT}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterPatient}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div
                      className={showRowSelection ? styles.patientPopoverWithSelection : styles.patientPopover}
                    >
                      <DropdownSearchPopover
                        noResultsMessage="No patient found"
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                        placeholder="MRN / Patient Name..."
                        isLoading={patients && patients.isFetching}
                        options={patientsOptions}
                        value={selectedPatient}
                        onChange={patient => handleOnFilterChange(PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS.PATIENT, patient)}
                        getOptionLabel={p => {
                          let optionLabel = getPatientName(p.firstName, p.lastName, '')
                          if (p.customParticipantID) {
                            optionLabel += `${PATIENT_NAME_MRN_SPLIT_DELIMITER}${p.customParticipantID}`
                          }
                          return optionLabel
                        }}
                        components={{
                          Option,
                          SingleValue,
                        }}
                        getOptionFilter={(option, input) => {
                          const patient = option.data
                          const fields = `${patient.lastName}, ${patient.firstName} ${patient.customParticipantID}`.toLowerCase()
                          const searchInputParts = input.toLowerCase().split(' ')
                          return searchInputParts.every(text => fields.includes(text))
                        }}
                        getOptionValue={d => d.id}
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ rowData }) => {
              const rec = rowData
              const primaryText = getPatientName(rec.firstName, rec.lastName, '')
              const secondaryText = rec.customParticipantID

              const secondaryTextClassName = `${TableStyles.secondaryText} ${TableStyles.number}`
              return (
                <div className={TableStyles.columnContent}>
                  <p className={TableStyles.primaryText}>
                    {primaryText}
                  </p>
                  <p className={secondaryTextClassName}>
                    {secondaryText}
                  </p>
                </div>
              )
            }}
          />
          <Column
            className={TableStyles.column}
            label="DOB"
            dataKey={PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS.DOB}
            width={DOB_WIDTH}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS.DOB}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterDate}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div
                      className={styles.datePopover}
                    >
                      <DatePopover
                        handleOnChange={dates => handleOnFilterChange(PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS.DOB, dates)}
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                        min={dateRange[0]}
                        max={dateRange[1]}
                        startDate={selectedStartDate}
                        endDate={selectedEndDate}
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ dataKey, rowData }) => {
              const patient = rowData
              const date = patient.dob && moment(patient.dob).format(this.dateFormat)

              return (
                <div className={TableStyles.centeredColumnContent}>
                  <p className={`${TableStyles.primaryText} ${TableStyles.centeredText}`}>
                    {date}
                  </p>
                </div>
              )
            }}
          />
          <Column
            className={TableStyles.column}
            label="Ordering Provider"
            dataKey={PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS.ORDERING_PHYSICIAN}
            width={ORDERING_PHYSICIAN_WIDTH}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS.ORDERING_PHYSICIAN}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterPhysician}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div
                      className={styles.physicianPopover}
                      data-action="filter-ordering-provider"
                    >
                      <MultiSelectListPopover
                        list={physicianOptions}
                        selected={selectedPhysicians}
                        getOptionLabel={d => d.label}
                        getOptionValue={d => d.id}
                        enableSearch={true}
                        handleOnClick={id => handleOnFilterChange(EKG_TABLE_COLUMN_HEADERS.ORDERING_PHYSICIAN, id)}
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                        controlShouldRenderValue={true}
                        backspaceRemovesValue={true}
                        onKeyDown={e => {
                          if (isEscKey(e)) {
                            handleOnOutsidePopoverClick()
                          }
                        }}
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ rowData }) => {
              const patient = rowData
              const physician = patient.orderingPhysician && getPhysicianName(patient.orderingPhysician.firstName, patient.orderingPhysician.lastName, '')

              return (
                <div className={TableStyles.columnContent}>
                  <p className={TableStyles.primaryText}>
                    {physician}
                  </p>
                </div>
              )
            }}
          />
          <Column
            className={TableStyles.column}
            label="Connection"
            dataKey={PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS.CONNECTION_STATUS}
            width={CONNECTION_STATUS_WIDTH}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS.CONNECTION_STATUS}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterConnectionStatus}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div
                      className={styles.connectionStatusPopover}
                    >
                      <MultiSelectListPopover
                        list={connectionStatusesOptions}
                        selected={selectedConnectionStatus}
                        getOptionLabel={d => d.label}
                        getOptionValue={d => d.id}
                        enableSearch={false}
                        handleOnClick={id => handleOnFilterChange(PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS.CONNECTION_STATUS, id)}
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ dataKey, rowData }) => {
              const patient = rowData
              let content

              switch (patient.connectionStatus) {
              case ENROLLMENT_CONNECTION_STATUSES.CONNECTED:
                content = (
                  <p className={styles.connectionStatusConnected}>
                    Connected
                  </p>
                )
                break
              case ENROLLMENT_CONNECTION_STATUSES.PENDING:
                content = (
                  <p className={styles.connectionStatusPending}>
                    Pending
                  </p>
                )
                break
              case ENROLLMENT_CONNECTION_STATUSES.DISCONNECTED:
              case ENROLLMENT_CONNECTION_STATUSES.REVOKED:
              case ENROLLMENT_CONNECTION_STATUSES.EXPIRED:
              case ENROLLMENT_CONNECTION_STATUSES.NONE:
              default:
                content = (
                  <p className={styles.connectionStatusNotConnected}>
                    Not Ordered
                  </p>
                )
                break
              }
              return (
                <div className={TableStyles.centeredColumnContent}>
                  {content}
                </div>
              )
            }}
          />
          <Column
            className={TableStyles.column}
            label="Connection Plan"
            dataKey={PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS.PRESCRIPTION}
            width={prescriptionWidth}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS.PRESCRIPTION}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterPrescription}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  lastElement={true}
                  Popover={(
                    <div
                      className={showRowSelection ? styles.prescriptionPopoverWithSelection : styles.prescriptionPopover}
                    >
                      <DropdownSearchPopover
                        noResultsMessage="No connection plan found"
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                        placeholder="Connection Plan..."
                        isLoading={prescriptions && prescriptions.isFetching}
                        options={prescriptionsOptions}
                        value={selectedPrescription}
                        onChange={prescription => handleOnFilterChange(PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS.PRESCRIPTION, prescription)}
                        getOptionLabel={p => p.name || ''}
                        getOptionValue={d => d.id}
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ dataKey, rowData }) => {
              const patient = rowData
              let currentEnrollment

              if (patient.enrollments && patient.enrollments.length > 0 && enrollments.data) {
                const pendingOrConnectedEnrollments = getPendingOrConnectedEnrollmentsByEndDate(patient.enrollments, enrollments.data.byId)

                if (pendingOrConnectedEnrollments.length > 0) {
                  currentEnrollment = pendingOrConnectedEnrollments[0]
                }
              }

              return (
                <div className={TableStyles.columnContent}>
                  <p className={TableStyles.primaryText}>
                    {currentEnrollment && currentEnrollment.connectionTemplateName}
                  </p>
                </div>
              )
            }}
          />
          <Column
            className={TableStyles.column}
            label="Billing Code"
            dataKey={PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS.BILLING_CODE}
            width={BILLING_CODE_WIDTH}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS.BILLING_CODE}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterBillingCode}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div
                      className={styles.billingCodesPopover}
                    >
                      <MultiSelectListPopover
                        list={billingCodesOptions}
                        selected={selectedBillingCode}
                        getOptionLabel={d => d.name}
                        getOptionValue={d => d.id}
                        enableSearch={false}
                        handleOnClick={billingCode => handleOnFilterChange(PATIENT_DIRECTORY_TABLE_COLUMN_HEADERS.BILLING_CODE, billingCode)}
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ dataKey, rowData }) => {
              const patient = rowData
              let currentEnrollment
              let text

              if (patient.enrollments && patient.enrollments.length > 0 && enrollments.data) {
                const pendingOrConnectedEnrollments = getPendingOrConnectedEnrollmentsByEndDate(patient.enrollments, enrollments.data.byId)

                if (pendingOrConnectedEnrollments.length > 0) {
                  currentEnrollment = pendingOrConnectedEnrollments[0]
                }
              }

              if (currentEnrollment && currentEnrollment.billingCodes && currentEnrollment.billingCodes.length > 0) {
                text = currentEnrollment.billingCodes[0].name
              }

              return (
                <div className={TableStyles.columnContent}>
                  <p className={TableStyles.primaryText}>
                    {text}
                  </p>
                </div>
              )
            }}
          />
        </Table>
      </div>
    )
  }
}

export default PatientDirectoryTable



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/PatientDirectoryTable/PatientDirectoryTable.jsx